export const styles = {
    userDetails:{
        height:"100vh",
        display:"flex",
        flexDirection:"column",
        alignItems:"center",
        justifyContent:"center",
        width:{
          xs:"auto",
          sm:"550px"
        },
        // maxWidth: "500px",
        margin:{
          xs:"0 15px",
          sm:"0 auto"
        },
    },
  userInfoSection: {
    // padding: 3,
    // borderBottom: "1px solid #ccc",
    marginBottom:3
  },
  userName: {
    marginBottom: 1,
  },
  languageSelectionSection: {
    margin: "0 auto",
   
  },
  languageButton:{
    margin:"16px 16px 16px 0",
    fontSize:"18px",
    textTransform: "uppercase"
  },
  subHeading:{
    margin:"10px 0"
  }
};
